var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPolicies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.814 3.265V8.93a8.86 8.86 0 005.68 8.27l.774.297a2.232 2.232 0 001.603 0l.775-.297a8.86 8.86 0 005.679-8.27V3.265a1.106 1.106 0 00-.646-1.014A16.148 16.148 0 008.07.904 16.148 16.148 0 001.46 2.25a1.107 1.107 0 00-.645 1.014z",
    fill: "#fff",
    stroke: "#6A737D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.284 10.28l1.65 1.044c.21.134.472-.065.41-.31l-.477-1.875a.286.286 0 01.093-.29l1.479-1.232c.194-.162.094-.484-.156-.5L9.351 6.99a.275.275 0 01-.237-.175l-.72-1.814a.272.272 0 00-.509 0l-.72 1.814a.275.275 0 01-.237.175l-1.932.126c-.25.016-.35.338-.155.5L6.32 8.848a.286.286 0 01.093.29l-.442 1.74c-.075.294.239.533.492.373l1.532-.972a.269.269 0 01.289 0z",
    fill: "#6A737D"
  })));
}
export default SvgIconPolicies;